import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { requiredTier, UPGRADE_URL } from "@/lib/plan";

export function UpgradeBanner({ feature, title, benefit, storageKey }) {
  const key = storageKey || `klt_upsell_${feature}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return !!localStorage.getItem(key); } catch { return false; }
  });
  if (dismissed) return null;
  const tier = requiredTier(feature);
  return (
    <div className="mb-5 rounded-2xl border border-primary/30 bg-gradient-to-r from-primary/10 to-primary/[0.04] p-4 sm:p-5 flex flex-wrap items-center gap-4" data-testid={`upsell-banner-${feature}`}>
      <div className="w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5 text-primary" />
      </div>
      <div className="flex-1 min-w-[220px]">
        <p className="font-semibold">{title}</p>
        <p className="text-sm text-foreground/70 mt-0.5">{benefit}</p>
      </div>
      <a
        href={UPGRADE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`upsell-cta-${feature}`}
        className="inline-flex items-center gap-1.5 rounded-xl bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:opacity-90 transition-opacity shrink-0"
      >
        Passer à {tier}
      </a>
      <button
        onClick={() => { try { localStorage.setItem(key, "1"); } catch { /* ignore */ } setDismissed(true); }}
        data-testid={`upsell-dismiss-${feature}`}
        className="text-muted-foreground hover:text-foreground p-1 rounded-lg"
        aria-label="Ignorer"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
